import { Component, inject, input } from '@angular/core';
import { ColorService } from '../../../../table/services/color.service';
import { Icon } from '../../models/icon.interface';

@Component({
  selector: 'pozi-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  colorService = inject(ColorService);

  icon = input.required<Icon>();
}
